export default "__VITE_ASSET__B9brO$1z__"